export type TenantClaims = {tenants?: Record<string, unknown>; sub?: string};
/** Display gating only: backend authentication remains responsible for signature verification. */
export function readSessionClaims(token: string): TenantClaims | null {
 try {const payload=token.split('.')[1];if(!payload)return null;return JSON.parse(atob(payload.replace(/-/g,'+').replace(/_/g,'/'))) as TenantClaims;} catch {return null;}
}
